import { AnswerValue } from '../air-question/air-question.types'

/**
 * Layout section.
 * Represents an UI block which holds question references or
 * sub-sections.
 */
export interface LayoutSection {
  ui: SectionUI
  meta: SectionMeta
  items: SectionItem[]
}

/**
 * Section item: Question ID or Section
 */
export type SectionItem = string | LayoutSection

/**
 * Collection of Section UI related properties.
 */
export interface SectionUI {
  title: string
  description?: string
}

export enum SectionMetaLabel {
  WxcClassQuestions = 'WcClassQuestions',
  IncludedCoverages = 'IncludedCoverages',
  OptionalCoverages = 'OptionalCoverages',
  Deductibles = 'Deductibles',
  BuildingLimits = 'BuildingLimits',
  PropertyLimits = 'PropertyLimits',
}

export interface SectionMetaFeatures {
  sum: string
}

/**
 * Collection of Section meta properties.
 */
export interface SectionMeta {
  /**
   * Defines the meaning of this section i.e. if it represents a section or a grouping of questions.
   */
  composition: SectionMetaComposition
  features?: SectionMetaFeatures
  /**
   * Allows the front-end to treat the group in a special way
   */
  label?: SectionMetaLabel
}

/**
 * The meaning of this section i.e. if it represents a section or a grouping of questions.
 */
export enum SectionMetaComposition {
  /**
   * A grouping of questions within the current section
   */
  Group = 'group',

  /**
   * A section is a collection of sections or groups
   */
  Section = 'section',
}

/**
 * Map of question IDs to answer values
 */
export type AnswerMap = {
  [id: string]: AnswerValue
}

/**
 * Event object emitted when an answer has changed or validation was triggered
 */
export type QuestionnaireEventDetail = {
  answers: AnswerMap
  completed: boolean
}
